import { render, staticRenderFns } from "./ShopDevices.vue?vue&type=template&id=31dc238b&scoped=true&"
import script from "./ShopDevices.vue?vue&type=script&lang=js&"
export * from "./ShopDevices.vue?vue&type=script&lang=js&"
import style0 from "./ShopDevices.vue?vue&type=style&index=0&id=31dc238b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dc238b",
  null
  
)

export default component.exports